export enum ServerIdentities {
  Secretary = 'Secretary',
  Moderator = 'Moderator',
}

export const ServerIdentitiesList: ServerIdentities[] = [
  ServerIdentities.Secretary,
  ServerIdentities.Moderator,
]

export const ServerIdentitiesIds: string[] = [
  ServerIdentities.Secretary,
  ServerIdentities.Moderator,
]

// LiveKit participant attribute the Secretary worker publishes on connect,
// carrying the backend transcription_run_id. The client reads it to join a
// browser observation to the exact backend run. Kept in sync with the Go
// constant util.LIVEKIT_ATTR_TRANSCRIPTION_RUN_ID.
export const SECRETARY_TRANSCRIPTION_RUN_ID_ATTRIBUTE = 'transcription_run_id'
